import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import './FeedbackButton.css';

function FeedbackButton() {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <button
        className="feedback-button"
        onClick={handleOpenModal}
        title="Give us feedback"
      >
        💬
      </button>

      {showModal && (
        <FeedbackModal
          show={showModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}

export default FeedbackButton;
